import { render, staticRenderFns } from "./PaidUserAccountSetup.vue?vue&type=template&id=612c0640&scoped=true"
import script from "./PaidUserAccountSetup.vue?vue&type=script&lang=js"
export * from "./PaidUserAccountSetup.vue?vue&type=script&lang=js"
import style0 from "./PaidUserAccountSetup.vue?vue&type=style&index=0&id=612c0640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612c0640",
  null
  
)

export default component.exports